import React from 'react';
import { OutstandingModalState } from '../useOutstandingActions';
import SettleOutstandingModal from './SettleOutstandingModal';
import ReasonConfirmModal from './ReasonConfirmModal';

interface OutstandingActionModalsProps {
  modal: OutstandingModalState;
  onClose: () => void;
  isSubmitting: boolean;
  onSettle: (amount: number, notes: string) => void;
  onRelease: (reason: string) => void;
  onOverride: (reason: string) => void;
}

/** The three settle/release/override modals, shared by the list and detail pages. */
const OutstandingActionModals: React.FC<OutstandingActionModalsProps> = ({
  modal,
  onClose,
  isSubmitting,
  onSettle,
  onRelease,
  onOverride,
}) => (
  <>
    <SettleOutstandingModal
      isOpen={modal?.type === 'settle'}
      onClose={onClose}
      isSubmitting={isSubmitting}
      outstanding={modal?.type === 'settle' ? modal.row : null}
      onSubmit={onSettle}
    />

    <ReasonConfirmModal
      isOpen={modal?.type === 'release'}
      onClose={onClose}
      isSubmitting={isSubmitting}
      title="Release Outstanding"
      description="Tulis off sisa tagihan ini. Tercatat sebagai write-off, bukan dihapus."
      reasonLabel="Release Reason"
      reasonPlaceholder="Contoh: unit hilang dan sudah diklaim asuransi"
      submitLabel="Release"
      submitVariant="danger"
      onSubmit={onRelease}
    />

    <ReasonConfirmModal
      isOpen={modal?.type === 'override'}
      onClose={onClose}
      isSubmitting={isSubmitting}
      title="Allow New Rental"
      description="Izinkan driver ini mulai sewa baru meski outstanding masih terbuka. One-shot — otomatis terpakai begitu sewa baru dibuat."
      reasonLabel="Override Reason"
      reasonPlaceholder="Contoh: driver dengan riwayat baik, diizinkan sambil mencicil"
      submitLabel="Allow"
      onSubmit={onOverride}
    />
  </>
);

export default OutstandingActionModals;
